// action
export function addTestSchools({ commit }){
    commit('ADD_TEST_SCHOOLS');
}